import { Instant } from '@js-joda/core';
import { useSignals } from '@preact/signals-react/runtime';
import { useContainer } from 'src/features/ioc';
import type { RootState } from 'src/store';
import { useSelector } from 'src/store/hooks';

const selectUser = (state: RootState) => state.auth?.masqUser ?? state.auth?.user;
export const useUser = () => {
    useSignals();
    const legacyUser = useSelector(selectUser);
    return useContainer().getOptional('CurrentUserModel')?.user.value ?? legacyUser;
};

export const selectAccessToken = (state: RootState) => state.auth?.masqAccessToken ?? state.auth?.accessToken;
export const useAccessToken = () => {
    useSignals();
    const masqToken = useSelector((state: RootState) => state.auth?.masqAccessToken);
    const session = useContainer().get('SessionService');
    const token = session.accessToken.value;
    const state = session.state.value;
    const expires =
        (state.phase === 'authenticated' || state.phase === 'refreshing') && typeof state.claims.exp === 'number'
            ? Instant.ofEpochSecond(state.claims.exp)
            : undefined;

    return masqToken ?? (token ? { token, expires } : null);
};
